<portal-modal (clickedOutside)="handleExitClick.emit()">
	<div modalHeader class="flex justify-between">
		<h2 class="semi-bold">
			<i class="fa fa-history mgn-right10 green-text" aria-hidden="true"></i>
			Edit History Note
		</h2>

		<button
			(click)="handleExitClick.emit()"
			type="button"
			class="bg-gray-200 !w-auto hover:bg-gray-300 focus:ring-4 focus:ring-gray-300 font-medium rounded text-sm px-3 py-1"
		>
			<i class="fas fa-times"></i>
		</button>
	</div>
	<div modalContent class="flex flex-col gap-4 mt-8">
		<div class="flex flex-col">
			<label>Subject</label>
			<input placeholder="Subject" [(ngModel)]="historyNotesService.selectedHistoryNote.LogSubject" class="h-10 !bg-gray-200 border-0" />
		</div>
		<div>
			<label>Notes</label>
			<div
				contenteditable="true"
				[innerHTML]="historyNotesService.selectedHistoryNote.LogMessage"
				(input)="onHtmlInput($event)"
				class="border p-2 min-h-[12rem] max-h-[550px] overflow-auto rounded bg-gray-200 focus-visible:outline-transparent"
			></div>
		</div>
	</div>
	<div modalFooter class="flex justify-between gap-4 mt-8">
		<button
			(click)="handleExitClick.emit()"
			type="button"
			class="!w-auto text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded text-sm px-5 py-2.5"
		>
			Cancel
		</button>
		<button
			(click)="onSaveClick()"
			type="button"
			class="!w-auto text-white bg-teal-600 hover:bg-teal-700 focus:ring-4 focus:ring-teal-300 font-medium rounded text-sm px-5 py-2.5 focus:outline-none"
		>
			Save
		</button>
	</div>
</portal-modal>
